import { Box } from '@chakra-ui/react';
import { Text } from '@kula-ai/components';
import type { DashboardSection } from '../../../types';

export const CalloutSection = ({ section }: { section: DashboardSection }) => (
  <Box bg="primary-50" borderRadius="10px" px="12px" py="10px">
    <Text variant="small" className="text-[14px] text-secondary-700">
      {section.text}
    </Text>
  </Box>
);
